/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import '@quasar/extras/roboto-font/roboto-font.css'

import '@quasar/extras/material-icons/material-icons.css'



import '@quasar/extras/animate/slideInLeft.css'

import '@quasar/extras/animate/slideInRight.css'

import '@quasar/extras/animate/slideOutLeft.css'

import '@quasar/extras/animate/slideOutRight.css'

import '@quasar/extras/animate/slideInUp.css'

import '@quasar/extras/animate/slideOutUp.css'

import '@quasar/extras/animate/fadeIn.css'

import '@quasar/extras/animate/fadeOut.css'


// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'




import 'src/css/app.scss'


import Vue from 'vue'
import createApp from './app.js'




import qboot_Bootpolyfillts from 'boot/polyfill.ts'

import qboot_Bootsentryts from 'boot/sentry.ts'

import qboot_Bootvuegtagts from 'boot/vue-gtag.ts'

import qboot_Bootdirectivests from 'boot/directives.ts'

import qboot_Boothooksts from 'boot/hooks.ts'

import qboot_Bootfiltersts from 'boot/filters.ts'

import qboot_Bootfontawesomeprots from 'boot/fontawesome-pro.ts'

import qboot_Bootvmaskts from 'boot/v-mask.ts'

import qboot_Bootgmapvuets from 'boot/gmap-vue.ts'

import qboot_Bootvuexts from 'boot/vuex.ts'












const publicPath = `/`


async function start () {
  const { app, store, router } = await createApp()

  

  
  let hasRedirected = false
  const redirect = url => {
    hasRedirected = true
    const normalized = Object(url) === url
      ? router.resolve(url).route.fullPath
      : url

    window.location.href = normalized
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  const bootFiles = [qboot_Bootpolyfillts,qboot_Bootsentryts,qboot_Bootvuegtagts,qboot_Bootdirectivests,qboot_Boothooksts,qboot_Bootfiltersts,qboot_Bootfontawesomeprots,qboot_Bootvmaskts,qboot_Bootgmapvuets,qboot_Bootvuexts]

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        store,
        Vue,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  

    

    

    
      new Vue(app)
    

    

    

  

}

start()
